import React, { useState } from 'react';
import { searchNDISItems, getAllCategories, getCategoryForItem } from '../utils/ndisUtils';
import ndisDatabase from '../ndis_pricing_database.json';

const ITEMS_PER_PAGE = 20;

function Services() {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  
  const categories = getAllCategories();

  const handleSearch = (query) => {
    setSearchQuery(query);
    setCurrentPage(1);
    if (query.length >= 2) {
      let results = searchNDISItems(query);
      
      if (selectedCategory !== 'all') {
        results = results.filter(item => getCategoryForItem(item) === selectedCategory);
      }
      
      setSearchResults(results);
    } else {
      setSearchResults([]);
    }
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setCurrentPage(1);
    if (searchQuery.length >= 2) {
      let results = searchNDISItems(searchQuery);
      if (category !== 'all') {
        results = results.filter(item => getCategoryForItem(item) === category);
      }
      setSearchResults(results);
    }
  };

  const filteredItems = selectedCategory === 'all' 
    ? ndisDatabase 
    : ndisDatabase.filter(item => getCategoryForItem(item) === selectedCategory);

  const displayItems = searchQuery.length >= 2 ? searchResults : filteredItems;
  const totalPages = Math.max(1, Math.ceil(displayItems.length / ITEMS_PER_PAGE));
  const paginatedItems = displayItems.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);

  return (
    <div className="services-page">
      <h1>NDIS Pricing Guide</h1>
      <p className="page-subtitle">Browse and search the complete NDIS pricing database</p>

      <div className="services-filters">
        <div className="search-bar">
          <input
            type="text"
            placeholder="Search services... (e.g., 'community saturday', 'transport')"
            value={searchQuery}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>

        <div className="category-filter">
          <label>Category:</label>
          <select 
            value={selectedCategory} 
            onChange={(e) => handleCategoryChange(e.target.value)}
          >
            <option value="all">All Categories</option>
            {categories.map(cat => (
              <option key={cat} value={cat}>{cat}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="services-count">
        Showing {displayItems.length} service{displayItems.length !== 1 ? 's' : ''}
      </div>

      <div className="services-list">
        {paginatedItems.map(item => (
          <div key={item.item_code} className="service-card">
            <div className="service-header">
              <span className="service-code">{item.item_code}</span>
              <span className="service-category">{getCategoryForItem(item)}</span>
            </div>
            <div className="service-description">{item.description}</div>
            <div className="service-details">
              {item.day_type && <span className="detail-tag">{item.day_type}</span>}
              {item.time_type && <span className="detail-tag">{item.time_type}</span>}
            </div>
            <div className="service-pricing">
              {item.quote_based ? (
                <div className="price-item">
                  <em>Quote-based — contact provider</em>
                </div>
              ) : (
                <>
                  <div className="price-item">
                    <span>National:</span>
                    <strong>${item.national_price}/{item.unit}</strong>
                  </div>
                  {item.remote_price && (
                    <div className="price-item">
                      <span>Remote:</span>
                      <strong>${item.remote_price}/{item.unit}</strong>
                    </div>
                  )}
                  {item.very_remote_price && (
                    <div className="price-item">
                      <span>Very Remote:</span>
                      <strong>${item.very_remote_price}/{item.unit}</strong>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        ))}
      </div>

      {totalPages > 1 && (
        <div className="pagination-controls">
          <button
            className="btn btn-secondary"
            onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span className="pagination-info">Page {currentPage} of {totalPages}</span>
          <button
            className="btn btn-primary"
            onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}

export default Services;
